// extracted by mini-css-extract-plugin
export default {"modalContent":"Styles_modalContent__xZDmt","danger":"Styles_danger__F7CJk","success":"Styles_success__eupRS","contentText":"Styles_contentText__-Dqr1"};